import React from 'react';
import styles from './Device.module.scss';
import { getTranslation } from '../../../../../../utils/translation';

export default function ({ icon, name, status }) {
    const refreshPage = () => {
        window.location.reload();
    };

    return (
        <div className={styles.device}>
            <div className={styles.deviceDetail}>
                <span className={`${icon} ${styles.deviceIcon}`} />
                <span className={styles.deviceName}>{name}</span>
                <span className={`${styles.status} ${status ? styles.online : styles.offline}`}>
                    {status
                        ? getTranslation('internetConnectionOnline')
                        : getTranslation('internetConnectionOffline')}
                </span>
            </div>
            <button className={styles.deviceRefreshBtn} onClick={refreshPage}>
                {getTranslation('allDevicesModalRefresh')}
            </button>
        </div>
    );
}
